import actionCreatorFactory from 'typescript-fsa';
// actionのprefixを設定
const actionCreator = actionCreatorFactory('endpointStatusSubdiv');

const get = actionCreator.async<
  {
    koujiBangou: string
  }, // started: parameter type
  {
    status: string
  }, // done: success type
  {
    error: string
  } // failed: error type
  >('GET');

export {
  get
};



// WEBPACK FOOTER //
// ./src/redux/modules/endpointStatusSubdiv/actions.ts